import React from 'react';
import { ChevronRightIcon, DocumentIcon } from '@heroicons/react/24/outline';
import { readResultManifest } from '../../../shared/coworkResultManifest';
import MarkdownImage, { type MarkdownImageLoader } from '../MarkdownImage';

/** 本轮交付物卡片；复用会话图片读取器和预览入口，不直接请求沙箱文件路径。 */
export default function ResultManifestCards({ manifest, loadImage, onFileClick }: {
  manifest: unknown;
  loadImage?: MarkdownImageLoader;
  onFileClick?: (filePath: string) => void;
}): React.ReactElement | null {
  const result = readResultManifest(manifest);
  if (!result?.artifacts.length) return null;
  return <div className="space-y-2" aria-label="本轮生成文件">
    {result.artifacts.map(artifact => <div key={artifact.path}
      className="w-full flex items-center gap-3 rounded-xl px-4 py-3 text-left bg-claude-surface/50 dark:bg-white/5">
      <span className="h-12 w-12 shrink-0 overflow-hidden rounded-lg flex items-center justify-center">
        {artifact.exists !== false && loadImage && /\.(?:png|jpe?g|webp|gif|avif|bmp)$/i.test(artifact.path)
          ? <MarkdownImage src={artifact.path} alt={artifact.name} loadImage={loadImage} className="h-12 w-12 object-cover" />
          : <DocumentIcon className="h-7 w-7 text-gray-400" />}
      </span>
      <button type="button" disabled={artifact.exists === false || !onFileClick}
        onClick={() => onFileClick?.(artifact.path)}
        className="flex-1 min-w-0 flex items-center gap-3 text-left disabled:opacity-60">
        <span className="flex-1 min-w-0">
          <span className="block truncate font-medium">{artifact.name}</span>
          <span className="block text-xs text-gray-500 mt-1">{artifact.exists === false ? '文件暂不可用，请重试任务' : typeof artifact.size === 'number' ? `${Math.max(1, Math.round(artifact.size / 1024))} KB` : '查看文件'}</span>
        </span>
        <ChevronRightIcon className="h-5 w-5 text-gray-400" />
      </button>
    </div>)}
  </div>;
}
